@if (fileContentModel) {
  <div
    class="modal fade ack-Zindex"
    tabindex="-1"
    id="previewModal"
    role="dialog"
    data-backdrop="static">
    <div class="modal-dialog modal-xl">
      <div class="modal-content new-nomination-pop-up">
        @if (!fileContentModel.fileFound) {
          <div class="col-11">
            <p class="ms-fontSize-m ms-fontWeight-bold customer-error mb-1">
              The File is not found in Blob !
            </p>
          </div>
        }
        <div class="modal-body ack-modal-body p-0">
          @if (checkIsImage(fileContentModel.previewFileType)) {
            <img
              class="uploaded-img mr-2 ack-prev-image"
              alt="Preview File"
              [src]="fileContentModel.fileUrl" />
          }

          @if (checkIsPdf(fileContentModel.previewFileType)) {
            <pdf-viewer
              class="ack-prev-pdf"
              id="pdfViewer"
              [src]="fileContentModel.fileUrl"
              [show-borders]="true"
              [render-text]="true"
              (after-load-complete)="afterPdfLoadComplete($event)"></pdf-viewer>
          }

          @if (checkIsDoc(fileContentModel.previewFileType)) {
            <ngx-doc-viewer
              [url]="fileContentModel.fileUrl"
              [viewer]="$any(viewerName)"
              style="width: 100%; height: 70vh"></ngx-doc-viewer>
          }

          @if (checkIsUnSupportedFileType(fileContentModel.previewFileType)) {
            <div>
              <label for="unsupportedFileType">Unsupported file Type</label>
              <input type="text" id="unsupportedFileType" hidden />
            </div>
          }
        </div>

        <div
          class="modal-footernew-nomination-modal-footer-padding mr-3 ml-3 pr-0"></div>
      </div>
    </div>
  </div>
}
